import React, { FC } from "react";

import Breakpoints from "./Breakpoints";
import NumericEditor from "./NumericEditor";

const numberComparator = (a: number, b: number) => a - b;

export interface NumericBreakpointsProps {
  breakpoints?: number[];
  onChange?: (value: number[]) => void;
}

const NumericBreakpoints: FC<NumericBreakpointsProps> = ({ breakpoints, onChange }) => {
  return (
    <Breakpoints
      comparator={numberComparator}
      editComponent={NumericEditor}
      onChange={onChange}
      value={breakpoints}
    />
  );
};

export default NumericBreakpoints;
